import { TooltipArrow, TooltipContent, TooltipTrigger } from '@radix-ui/react-tooltip';
import styled, { keyframes } from 'styled-components';

export const StyledOutDivider = styled.div`
  height: 0.1rem;
  background-color: ${({ theme }) => theme.colors.border.dark};

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: 0;
    background-color: unset;
  }
`;

export const StyledInDivider = styled.div`
  height: 0;
  background-color: unset;

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    height: 0.1rem;
    background-color: ${({ theme }) => theme.colors.border.dark};
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const StyledTooltipContent = styled(TooltipContent)`
  display: flex;
  gap: 0.3rem;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: ${({ theme }) => theme.radius.small};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  opacity: 1;
  z-index: 1001;
  padding: 1.2rem;
  max-width: 30rem;
  animation: 0.5s ${fadeIn} ease-out;
`;

export const StyledTooltipArrow = styled(TooltipArrow)`
  fill: ${({ theme }) => theme.colors.background.tertiary};
`;

export const StyledTooltipText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: normal;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledTooltipTrigger = styled(TooltipTrigger)`
  &:not(:first-child) {
    margin-left: 1.6rem;
  }
`;

export const StyledChildWrapper = styled.div<{ $isMitre?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 3rem;
  align-self: stretch;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    width: ${({ $isMitre }) => ($isMitre ? '65%' : '100%')};
  }
  @media screen and (min-width: ${({ theme }) => theme.sizes.xl}) {
    width: ${({ $isMitre }) => ($isMitre ? '80%' : '100%')};
  }
`;

export const StyledManagementDashboardFooterWrapper = styled.div`
  margin-top: auto;
  width: 100%;
`;

export const StyledErrorText = styled.div`
  display: flex;
  align-items: center;
`;
